import {
  cityField,
  houseNumberField,
  postalCodeField,
  streetField,
} from "toptaal-shared"
import { z } from "zod"

export const onboardingStudentAddressInfoSchema = z.object({
  postalCode: postalCodeField,
  houseNumber: houseNumberField,
  houseNumberAddition: z.string().nullable().optional(),
  street: streetField,
  city: cityField,
})

export type OnboardingStudentAddressInfoInput = z.input<
  typeof onboardingStudentAddressInfoSchema
>

export type OnboardingStudentAddressInfoOutput = z.infer<
  typeof onboardingStudentAddressInfoSchema
>
